import LabServiceModel from "@/models/LabServiceModel";
import ProjectModel from "./ProjectModel";
import ProjectStatusModel from "./ProjectStatusModel";

export default class ProjectStatusLogModel extends LabServiceModel {

  modelName() {
    return 'project-status-log';
  }

  defaults() {
    return {
      id: null,
      project_id: null,
      project: null,
      project_status_id: null,
      project_status: null,
      start_date: null,
      end_date: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      project_id: (val) => (this.nullStringMutator(val)),
      project_status_id: (val) => (this.nullStringMutator(val)),
      start_date: (val) => (this.nullStringMutator(val)),
      end_date: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }

  // Attribute validation
  validation() {
    return {}
  }

  getProject() {
    return this.getRelatedModel(ProjectModel, 'project');
  }

  getProjectStatus() {
    return this.getRelatedModel(ProjectStatusModel, 'project_status');
  }

}
